/* eslint-disable */
/**
 * @desc 组件自动化注册
 */
Vue.component('fast-reply', () => import( /* webpackChunkName: "componentsfast-reply" */ './fast-reply/index.vue'));
Vue.component('line-echarts', () => import( /* webpackChunkName: "componentsline-echarts" */ './line-echarts/index.vue'));

import Vue from 'vue'